import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "space-y-1 w-full h-10" }
const _hoisted_2 = {
  id: "listbox-label",
  class: "block text-sm leading-5 font-medium text-gray-700 h-full"
}
const _hoisted_3 = { class: "relative h-full" }
const _hoisted_4 = { class: "inline-block w-full rounded-md shadow-sm h-full" }
const _hoisted_5 = { class: "flex items-center space-x-3 h-full" }
const _hoisted_6 = { class: "block truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7 7l3-3 3 3m0 6l-3 3-3-3",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_8 = { class: "absolute mt-1 w-full rounded-md bg-white shadow-lg" }
const _hoisted_9 = {
  tabindex: "-1",
  id: "listbox-label",
  role: "listbox",
  "aria-labelledby": "listbox-label",
  "aria-activedescendant": "listbox-item-3",
  class: "max-h-56 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
}
const _hoisted_10 = ["id", "tabindex", "onClick"]
const _hoisted_11 = { class: "flex items-center space-x-3" }
const _hoisted_12 = { class: "absolute inset-y-0 right-0 flex items-center pr-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _renderSlot(_ctx.$slots, "SelectLabel")
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
          id: "openButton",
          "aria-haspopup": "listbox",
          "aria-expanded": "true",
          "aria-labelledby": "listbox-label",
          class: _normalizeClass(["cursor-pointer relative w-full h-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5", _ctx.colorClasses])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.updatedValue ? _ctx.updatedValue[_ctx.field] : 'Sélectionnez'), 1)
          ]),
          _hoisted_7
        ], 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              id: `listbox-item-${index}`,
              tabindex: index,
              role: "option",
              class: _normalizeClass(_ctx.colorClasses),
              onClick: ($event: any) => (_ctx.select(item))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(["block truncate", { 'font-normal' : !_ctx.isSelected(item).value , 'font-semibold' : _ctx.isSelected(item).value}])
                }, _toDisplayString(item[_ctx.field]), 3)
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_12, _hoisted_14, 512), [
                [_vShow, _ctx.isSelected(item).value]
              ])
            ], 10, _hoisted_10))
          }), 128))
        ])
      ], 512), [
        [_vShow, _ctx.isOpen]
      ])
    ])), [
      [_directive_click_outside, _ctx.closeDropdown]
    ])
  ]))
}